<div class="report-container">
    <div id="reportFilter" class="filter-container">
        <div class="dx-fieldset">
            <div class="dx-field">
                <div class="dx-field-container">
                    <div class="dx-field-label report_label">Core Range:</div>
                    <div class="dx-field-value">
                        <dx-select-box id="coreRangeFilter"
                                       [searchEnabled]="true"
                                       placeholder="Select a range..."
                                       searchMode="contains"
                                       [dataSource]="rangeNames"
                                       [(value)]="selectedRangeName"
                                       width="auto">
                            <dx-validator [validationGroup]="validationGroup">
                                <dxi-validation-rule type="required" message=" "></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
            </div>
        </div>

        <div class="options-filter">
            <div class="check-box"></div>
            <div class="button-wrapper">
                @if (!loading) {
                    <dx-button class="dx-widget dx-button dx-button-mode-contained dx-button-default dx-button-has-text"
                               style="width: 150px;"
                               [useSubmitBehavior]="true"
                               [validationGroup]="validationGroup"
                               (onClick)="exportReport()">
                        <div class="dx-button-content">
                            <div class="dx-button-text">Export<i class="dx-icon-export"></i></div>
                        </div>
                    </dx-button>
                } @else {
                    <dx-button class="dx-widget dx-button dx-button-mode-contained dx-button-default dx-button-has-text loading-button"
                               [disabled]="true"
                               style="width: 150px;">
                        <div class="dx-button-content">
                            <div class="lds-dual-ring"></div>
                        </div>
                    </dx-button>
                }
            </div>
        </div>
    </div>
    <dx-validation-summary [validationGroup]="validationGroup"></dx-validation-summary>
</div>
